export const platformStats = {
  totalVideos: '50,000+',
  dailyUpdates: '200+',
  activeUsers: '8,000万',
  satisfaction: '98.5%',
  yearsRunning: 12,
  categories: 6,
};

export const features = [
  {
    icon: 'ri-vip-diamond-line',
    title: '海量高清资源',
    description: '超过五万部高清视频资源，涵盖电视剧、电影、综艺、动漫、纪录片等多种类型，满足你的全部观影需求。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放体验',
    description: '采用先进的视频加速技术，智能CDN节点全球部署，确保流畅播放不卡顿，给你丝滑般的观影体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定访问',
    description: '多重安全防护机制，数据加密传输，隐私保护无忧。提供多个备用入口，保证随时随地稳定访问。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日持续更新',
    description: '专业内容团队每日更新超过200部资源，紧跟热点，让你第一时间看到最新最热的精彩内容。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20man%20portrait%20photo%20with%20warm%20natural%20lighting%2C%20simple%20clean%20background&width=100&height=100&seq=avatar-01&orientation=squarish',
    comment: '用了俺去也三年了，资源真的多，更新也快，基本上想看的都能找到。播放体验也很流畅，很少遇到卡顿的情况。',
    rating: 5,
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20woman%20portrait%20photo%20with%20soft%20natural%20lighting%2C%20simple%20clean%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    comment: '朋友推荐的这个平台，没想到这么好用。界面简洁大方，分类清晰，找剧很方便。最重要的是完全免费，太良心了！',
    rating: 5,
  },
  {
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20student%20portrait%20photo%20with%20bright%20natural%20lighting%2C%20simple%20clean%20background&width=100&height=100&seq=avatar-03&orientation=squarish',
    comment: '作为动漫迷，俺去也的动漫资源真的没话说！更新速度比很多专门动漫网站都快，画质也很好，强烈安利！',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '俺去也需要注册才能观看吗？',
    answer: '不需要！俺去也始终坚持免费开放的理念，所有用户无需注册即可免费观看平台上的全部内容。我们致力于降低用户的访问门槛，让每个人都能轻松享受丰富的娱乐资源。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '如果您遇到播放卡顿的情况，可以尝试以下方法：1）切换视频清晰度，选择较低的清晰度播放；2）暂停缓冲片刻后再播放；3）检查您的网络连接是否稳定；4）尝试刷新页面后重新播放。我们的服务器采用全球CDN加速，正常情况下都能保证流畅播放。',
  },
  {
    question: '内容多久更新一次？',
    answer: '我们的内容团队每天都会更新资源，日均更新量超过200部。热门剧集和电影通常会在上线后24小时内同步更新，确保您能第一时间看到最新内容。部分热门资源还会提供多版本选择。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '俺去也支持全平台观看，包括PC电脑、平板、手机等各种设备。我们的网站采用了响应式设计，会根据您的设备自动调整最佳的显示效果，无论用什么设备都能获得良好的观看体验。',
  },
  {
    question: '如果入口地址无法访问怎么办？',
    answer: '我们提供多个备用入口地址，确保您随时随地都能稳定访问。如果当前入口无法访问，可以尝试通过我们的官方社交媒体账号获取最新入口地址。我们也会定期更新入口信息，确保访问的稳定性。',
  },
];